// extracted by mini-css-extract-plugin
export var layoutContainer = "_72-0";
export var layoutContainerNoRounding = "_72-6";
export var layoutContainerOpen = "_72-5";
export var layoutContainerResizing = "_72-1";
export var mainContent = "_72-2";
export var resizeDivider = "_72-3";
export var slidePanel = "_72-4";